"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _index = require("../index");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Close = function Close(props) {
  var id = props.id,
    _props$width = props.width,
    width = _props$width === void 0 ? 16 : _props$width,
    _props$height = props.height,
    height = _props$height === void 0 ? 16 : _props$height,
    _props$color = props.color,
    color = _props$color === void 0 ? '#6F6F6F' : _props$color,
    _props$title = props.title,
    title = _props$title === void 0 ? 'close' : _props$title,
    _props$description = props.description,
    description = _props$description === void 0 ? 'close' : _props$description;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title), /*#__PURE__*/_react["default"].createElement("desc", null, description), /*#__PURE__*/_react["default"].createElement("g", {
    id: "UI-Design_Final",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Britive-Admin_Add-a-Tenant-Copy",
    transform: "translate(-1280.000000, -88.000000)",
    fill: color
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1288,93.9429621 L1292.62834,89.3146268 C1293.19637,88.7465915 1294.11734,88.7465915 1294.68537,89.3146268 C1295.25341,89.8826621 1295.25341,90.8036294 1294.68537,91.3716647 L1290.05704,96 L1294.68537,100.628335 C1295.25341,101.196371 1295.25341,102.117338 1294.68537,102.685373 C1294.11734,103.253409 1293.19637,103.253409 1292.62834,102.685373 L1288,98.0570379 L1283.37166,102.685373 C1282.80363,103.253409 1281.88266,103.253409 1281.31463,102.685373 C1280.74659,102.117338 1280.74659,101.196371 1281.31463,100.628335 L1285.94296,96 L1281.31463,91.3716647 C1280.74659,90.8036294 1280.74659,89.8826621 1281.31463,89.3146268 C1281.88266,88.7465915 1282.80363,88.7465915 1283.37166,89.3146268 L1288,93.9429621 Z",
    id: "Close"
  }))));
};
Close.propTypes = _index.iconProps;
var _default = Close;
exports["default"] = _default;